import baustein from "baustein";
import globalEvents from "web/script/utils/global-events";
import analytics from "web/script/analytics/analytics";


export default baustein.register("feed-survey", {
    setupEvents(add) {
        add("click", ".feed-survey-answer__no", this.onClickNo);
        add("click", ".feed-survey-answer__yes", this.onClickYes);
        add("input", ".feed-survey-response__other-text", this.enableSubmit);
        add("submit", ".feed-survey__form", this.onSubmit);
    },

    onClickNo() {
        this.selectNo();
        analytics.event("feed-survey", "click", "no");
        this.onSubmit();
    },

    onClickYes() {
        this.selectYes();
        analytics.event("feed-survey", "click", "yes");
    },

    enableSubmit() {
        var text = this.el.querySelector(".feed-survey-response__other-text").value;
        if (text.length > 0) {
            this.el.querySelector(".feed-survey__submit").removeAttribute("disabled");
        } else {
            this.el.querySelector(".feed-survey__submit").setAttribute("disabled", "disabled");
        }
    },

    onSubmit() {
        var form = this.el.querySelector(".feed-survey__form");
        const answer = this.surveyAnswer();

        let payload = {
            survey_id: "feed-survey",
            response_json: JSON.stringify({
                question: this.el.querySelector(".feed-survey__title").textContent,
                answer,
                text: form.response_other.value,
            }),
        };

        analytics.trackWithMetaData("survey_response", payload);
        analytics.event("feed-survey", "submit", answer);

        this.close();
    },

    close() {
        globalEvents.trigger("feed-survey-closed");
        return this.destroy();
    },

    surveyAnswer() {
        return this.el.dataset.answer;
    },

    selectNo() {
        this.el.dataset.answer = false;
    },

    selectYes() {
        this.el.dataset.answer = true;
        this.el.classList.remove("feed-survey-state-1");
        this.el.classList.add("feed-survey-state-2");
    },
});
